module.exports = __webpack_public_path__ + "static/media/powered_by_stripe.6ecf0b9a.svg";